import React from "react";

import { isEmpty } from "lodash/fp";

import { SearchCompatibleAnnotatedText } from "@app/analytics/components/AnnotatedText";
import type { NoteSearchResult } from "@app/analytics/MeetingReport/types";
import { chunkNoteBySearchResults } from "@app/analytics/MeetingReport/utils";

import { ChapterDescription } from "./styles";

const AnnotatedChapterDescription = ({
  description,
  searchResults = [],
}: {
  description: string;
  searchResults?: NoteSearchResult[];
}) => {
  if (isEmpty(searchResults)) {
    return <ChapterDescription>{description}</ChapterDescription>;
  }

  const descriptionChunks = chunkNoteBySearchResults(
    description,
    searchResults
  );

  return (
    <ChapterDescription>
      {descriptionChunks.map((chunk) => (
        <SearchCompatibleAnnotatedText
          key={chunk.uniqueKey}
          highlighted={chunk.highlighted}
          searchIndex={chunk.highlightIndex}
        >
          {chunk.content}
        </SearchCompatibleAnnotatedText>
      ))}
    </ChapterDescription>
  );
};

export default AnnotatedChapterDescription;
